export default "__VITE_ASSET__C_vLJ5A$__"